import React, { useState, useEffect } from 'react';
import api from '../../services/api';

export default function Assignments() {
  const [assignments, setAssignments] = useState([]);
  const [employees, setEmployees]     = useState([]);
  const [courses, setCourses]         = useState([]);
  const [form, setForm]   = useState({ employee_id: '', course_id: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]     = useState('');
  const [search, setSearch] = useState('');

  const load = () => {
    Promise.all([
      api.get('/assignments'),
      api.get('/users/employees'),
      api.get('/courses'),
    ]).then(([ar, er, cr]) => {
      setAssignments(ar.data.data);
      setEmployees(er.data.data);
      setCourses(cr.data.data);
    }).finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const assign = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMsg('');
    try {
      await api.post('/assignments', form);
      setMsg('Course assigned successfully!');
      setForm({ employee_id: '', course_id: '' });
      load();
    } catch (err) {
      setMsg(err.response?.data?.message || 'Assignment failed');
    } finally {
      setSaving(false);
    }
  };

  const unassign = async (empId, courseId) => {
    if (!window.confirm('Remove this assignment?')) return;
    await api.delete('/assignments', { data: { employee_id: empId, course_id: courseId } });
    load();
  };

  const statusColors = { not_started: 'secondary', in_progress: 'primary', completed: 'success' };
  const filtered = assignments.filter(a =>
    (a.employee_name || '').toLowerCase().includes(search.toLowerCase()) ||
    (a.course_title || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <>
      <div className="row g-4">
        {/* Assign form */}
        <div className="col-md-4">
          <div className="content-section">
            <h6><i className="bi bi-person-plus-fill me-2 text-primary" />Assign Course</h6>
            {msg && <div className={`alert py-2 small ${msg.includes('success') ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}
            <form onSubmit={assign}>
              <div className="mb-3">
                <label className="form-label small fw-semibold">Employee</label>
                <select className="form-select form-select-sm" value={form.employee_id} onChange={e=>setForm({...form,employee_id:e.target.value})} required>
                  <option value="">Select employee...</option>
                  {employees.map(e => <option key={e.id} value={e.id}>{e.name} ({e.employee_id})</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label small fw-semibold">Course</label>
                <select className="form-select form-select-sm" value={form.course_id} onChange={e=>setForm({...form,course_id:e.target.value})} required>
                  <option value="">Select course...</option>
                  {courses.map(c => <option key={c.id} value={c.id}>{c.title}</option>)}
                </select>
              </div>
              <button type="submit" className="btn btn-primary btn-sm w-100" disabled={saving}>
                {saving ? 'Assigning...' : 'Assign Course'}
              </button>
            </form>
          </div>
        </div>

        {/* Table */}
        <div className="col-md-8">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-0">All Assignments ({assignments.length})</h6>
            <input className="form-control form-control-sm" style={{maxWidth:200}} placeholder="Search..." value={search} onChange={e=>setSearch(e.target.value)} />
          </div>
          {loading ? (
            <div className="text-center py-4"><div className="spinner-border text-primary" /></div>
          ) : (
            <div className="table-card">
              <table className="table table-hover align-middle mb-0">
                <thead><tr><th>Employee</th><th>Course</th><th>Assigned</th><th>Status</th><th></th></tr></thead>
                <tbody>
                  {filtered.length === 0 ? (
                    <tr><td colSpan={5} className="text-center text-muted py-3">No assignments found</td></tr>
                  ) : filtered.map(a => (
                    <tr key={a.id}>
                      <td>
                        <div className="small fw-semibold">{a.employee_name}</div>
                        <div className="text-muted" style={{fontSize:'.72rem'}}>{a.emp_id}</div>
                      </td>
                      <td className="small">{a.course_title}</td>
                      <td className="small text-muted">{new Date(a.assigned_date).toLocaleDateString('en-IN')}</td>
                      <td><span className={`badge bg-${statusColors[a.status]}`}>{a.status?.replace('_',' ')}</span></td>
                      <td><button className="btn btn-outline-danger btn-sm py-0 px-1" onClick={()=>unassign(a.employee_id,a.course_id)}><i className="bi bi-trash" /></button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
